import { JetView } from 'webix-jet';
import { devConfig, countries, profile, cashDesks, agentList } from 'config/config';

/**
 * Class representing the FilterFlujoCajaResumidoView.
 * @extends JetView
 */
export default class FilterFlujoCajaResumidoView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            minWidth: 200,
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'),
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(),
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries,
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect2',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry,
                            readonly: true,
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries,
                                },
                            },
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'combo',
                            name: 'BetShopId',
                            minWidth: 200,
                            label: "<span class='icon-shop'></span>" + _('Punto de Venta'),
                            hidden: !devConfig.getPermAction('filterByBetShop', 'Add'),
                            css: 'prm-filterByBetShop',
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            id: 'BetShopId',
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/BetShopsSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'text',
                            name: 'UserId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                        },
                    ],
                },
            ],
        };
        const left2 = {
            margin: 5,
            id: 'a2',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a2',
                    cols: [
                        {
                            view: 'radio',
                            name: 'WithCanceledBets',
                            id: 'WithCanceledBets',
                            label: _('Con apuestas anuladas?'),
                            labelPosition: 'top',
                            minWidth: 200,
                            height: screen.width < 600 || screen.height < 600 ? 100 : 0,
                            value: 1,
                            options: [
                                { id: 0, value: _('Si') },
                                { id: 1, value: _('No') },
                            ],
                        },
                        {
                            view: 'radio',
                            name: 'WithPendingAwards',
                            id: 'WithPendingAwards',
                            label: _('Con premios pendientes?'),
                            labelPosition: 'top',
                            minWidth: 200,
                            height: screen.width < 600 || screen.height < 600 ? 100 : 0,
                            value: 1,
                            options: [
                                { id: 0, value: _('Si') },
                                { id: 1, value: _('No') },
                            ],
                        },
                        {
                            view: 'radio',
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'),
                            labelPosition: 'top',
                            minWidth: 200,
                            height: screen.width < 600 || screen.height < 600 ? 100 : 0,
                            value: 1,
                            options: [
                                { id: 0, value: _('Detallado') },
                                { id: 1, value: _('Totales') },
                            ],
                        },
                        {
                            view: 'radio',
                            name: 'WithPaymentGateways',
                            id: 'WithPaymentGateways',
                            label: _('Con pasarelas de pago?'),
                            labelPosition: 'top',
                            minWidth: 200,
                            height: screen.width < 600 || screen.height < 600 ? 100 : 0,
                            value: 1,
                            options: [
                                { id: 0, value: _('Si') },
                                { id: 1, value: _('No') },
                            ],
                        },
                    ],
                },
            ],
        };
        const left3 = {
            margin: 5,
            id: 'a3',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a3',
                    cols: [
                        {
                            view: 'text',
                            name: 'UserIdAgent',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Concesionario'),
                            labelPosition: 'top',
                            placeholder: _('ID Concesionario'),
                            hidden: !devConfig.getPermAction('filterByAgent', 'Add'),
                            css: 'prm-filterByAgent',
                        },
                        {
                            view: 'text',
                            name: 'UserIdAgent2',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('Subconcesionario'),
                            labelPosition: 'top',
                            placeholder: _('Subconcesionario'),
                            hidden: !devConfig.getPermAction('filterByAgent2', 'Add'),
                            css: 'prm-filterByAgent2',
                        },
                        { id: 'grav2', gravity: 2 },
                    ],
                },
            ],
        };
        const left4 = {
            margin: 5,
            id: 'b2',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'b2',
                    cols: [
                        {
                            view: 'text',
                            name: 'DateCreatedBetShop',
                            id: 'DateCreatedBetShop',
                            css: 'reportrange3',
                            label:
                                "<span class='webix_icon icon-calendar'></span>" +
                                _('Fecha de creación punto de venta'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            on: {
                                onFocus: function (o, e, v) {
                                    $('.reportrange3 input').daterangepicker({
                                        ranges: {
                                            Today: [moment(), moment()],
                                            Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                                            'Last Month': [
                                                moment().subtract(1, 'month').startOf('month'),
                                                moment().subtract(1, 'month').endOf('month'),
                                            ],
                                        },
                                        locale: {
                                            format: 'YYYY-MM-DD',
                                        },
                                    });
                                },
                            },
                        },
                        {
                            view: 'datepicker',
                            name: 'DateCreatedBetShop2',
                            id: 'DateCreatedBetShop2',
                            stringResult: true,
                            minWidth: 200,
                            label:
                                "<span class='webix_icon icon-calendar'></span>" +
                                _('Fecha de creación punto de venta'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'),
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(),
                                },
                            },
                        },
                        { id: 'grav3', gravity: 3 },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
                {
                    margin: 10,
                    cols: [left2],
                },
                {
                    margin: 10,
                    cols: [left3],
                },
            ],
        };
        const upper_section2 = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left4],
                },
            ],
        };
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'),
                            body: {
                                padding: 10,
                                rows: [upper_section2],
                            },
                        },
                    ],
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'),
                    width: 100,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues());
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect);
                        $$('Datepicker').setValue('');
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = this.getRoot().getValues();
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry;
                        }
                        delete filterdata['CountrySelect2'];
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date'];
                            delete filterdata['DateCreatedBetShop2'];
                        } else {
                            if (true) {
                                delete filterdata['Datepicker'];
                                delete filterdata['DateCreatedBetShop'];
                            }
                        }
                        this.app.callEvent('flujoCajaResumido:filter', [filterdata]);
                        $$('b5').collapse();
                        $$('a5').scrollTo(100, 0);
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues());
                        $$('CountrySelect').setValue($$('myForm2').getCleanValues().CountrySelect);
                        $$('Datepicker').setValue('');
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues();
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry;
                        }
                        delete filterdata['CountrySelect2'];
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date'];
                            delete filterdata['DateCreatedBetShop2'];
                        } else {
                            if (true) {
                                delete filterdata['Datepicker'];
                                delete filterdata['DateCreatedBetShop'];
                            }
                        }
                        this.app.callEvent('flujoCajaResumido:filter', [filterdata]);
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section,
                                    devConfig.getPartnerSelected() == '8' ? accordion_section : { height: 1 },
                                    buttons,
                                ],
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section, accordion_section],
            },
        };
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2],
                rules: {
                    fname: webix.rules.isNotEmpty,
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2
                    : { id: 'right2', height: 1, width: screen.width - 54 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty,
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang();
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang);
        });
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav2').hide();
                $$('grav3').hide();
            }
            if (profile.typeDate !== 2) {
                $$('Date').hide();
                $$('Datepicker').show();
                $$('DateCreatedBetShop2').hide();
                $$('DateCreatedBetShop').show();
            } else {
                if (true) {
                    $$('Date').show();
                    $$('Datepicker').hide();
                    $$('DateCreatedBetShop2').show();
                    $$('DateCreatedBetShop').hide();
                }
            }
        });
    }
}

// FILE DOCUMENTED
